module.exports = __webpack_public_path__ + "static/records-links-e5767be60eef707ad968a3845e82bebe.png";